import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
import { EnvironmentService } from '../../service/service.module';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PromotionPlannerService {

  environment = EnvironmentService.environment;

  //Variables
  selectedPromotionPlannerItem: any;

  // Subjects
  public promotionPlannerGridActionCellSubject: Subject<any> = new Subject();
  public promotionPlannerUpsertSubject: Subject<any> = new Subject();
  public promotionPlannerItemActionSubject: Subject<any> = new Subject();

  /* Set Subjects for HEADER COLUMN EDIT/REMOVE */
  setPromotionPlannerGridActionCellSubject = (value: any) => { this.promotionPlannerGridActionCellSubject.next(value); };
  setPromotionPlannerUpsertSubject = (value: any) => { this.promotionPlannerUpsertSubject.next(value); };
  setPromotionPlannerItemActionSubject = (value: any) => { this.promotionPlannerItemActionSubject.next(value); };

  // Observables
  getPromotionPlannerGridActionCellSubject = () => this.promotionPlannerGridActionCellSubject.asObservable();
  getPromotionPlannerUpsertSubject = () => this.promotionPlannerUpsertSubject.asObservable();
  getPromotionPlannerItemActionSubject = () => this.promotionPlannerItemActionSubject.asObservable();


  constructor(private http: HttpClient) {
  }

  CreatePromotionPlannerItem(promtion: any) {
    return this.http.post<any>(`${this.environment.AppItemPromotionPlanner}/add`, promtion)
      .pipe(map(data => {
        return data;
      }));
  }

  UpdatePromotionPlannerItem(promotion: any) {
    return this.http.put(`${this.environment.AppItemPromotionPlanner}/update`, promotion)
      .pipe(map(data => {
        return data;
      }));
  }

  DeletePromotionPlannerItem(promotionId: string) {
    return this.http.delete(`${this.environment.AppItemPromotionPlanner}/delete?PromotionId=${promotionId}`)
      .pipe(map(data => {
        return data;
      }));
  }

  GetAllPromotionPlannerItems(offSet: number, pageSize: number) {
    return this.http.get(`${this.environment.AppItemPromotionPlanner}/getlist`)
      .pipe(map(data => {
        return data;
      }));
  }

  FilterPromotionPlannerItemList(body: any) {
    const query = Object.keys(body).map(key=> {
      return `${key}=${body[key]}`;
    }).join('&');
    return this.http.get(`${this.environment.AppItemPromotionPlanner}/getlist?${query}`)
      .pipe(map(data => {
        return data;
      }));
  }

  BulkAddPromotionPlannerDetailItems(body: any) {
    return this.http.post<any>(`${this.environment.AppItemPromotionPlanner}/bulkaddpromotiondetail`, body)
      .pipe(map(data => {
        return data;
      }));
  }

  BulkAddPromotionPlannerDetailItemsTransactional(body: any) {
    return this.http.post<any>(`${this.environment.AppItemPromotionPlanner}/bulkaddpromotiondetailtransactional`, body)
      .pipe(map(data => {
        return data;
      }));
  }

  CopyPromotionPlannerDetailItems(body: any) {
    return this.http.put<any>(`${this.environment.AppItemPromotionPlanner}/copypromotiondetail`, body)
      .pipe(map(data => {
        return data;
      }));
  }

  MovePromotionPlannerDetailItems(body: any) {
    return this.http.put<any>(`${this.environment.AppItemPromotionPlanner}/movepromotiondetail`, body)
      .pipe(map(data => {
        return data;
      }));
  }

  GetPromotionPlannerDetailItemList(promotionItemPlannerId: number) {
    return this.http.get(`${this.environment.AppItemPromotionPlanner}/getpromotiondetaillist?PromotionItemPlannerId=${promotionItemPlannerId}`)
      .pipe(map(data => {
        return data;
      }));
  }

  FilterPromotionPlannerDetailItemList(body: any) {
    const query = Object.keys(body).map(key=> {
      return `${key}=${body[key]}`;
    }).join('&');
    return this.http.get(`${this.environment.AppItemPromotionPlanner}/getpromotiondetaillist?${query}`)
      .pipe(map(data => {
        return data;
      }));
  }

  BulkUpdatePromotionPlannerDetailItems(body: any) {
    return this.http.post<any>(`${this.environment.AppItemPromotionPlanner}/bulkupdatepromotiondetail`, body)
      .pipe(map(data => {
        return data;
      }));
  }

  
  GetPromotionPlannerItemDetailWeeklyForecastList(pomotionPlannerItemId: number) {
    return this.http.get<any>(`${this.environment.AppItemPromotionPlanner}/GetPromotionItemPlannerDetailWeeklyForecastList?PromotionItemPlannerId=${pomotionPlannerItemId}`)
      .pipe(map(data => {
        return data;
      }));
  }

  BulkUpdatePromotionPlannerItemWeeklyForecastList(promotion: any) {
    return this.http.post<any>(`${this.environment.AppItemPromotionPlanner}/BulkUpdatePromotionPlannerWeeklyForecast`, promotion)
      .pipe(map(data => {
        return data;
      }));
  }


  FilterPromotionPlannerItemDetailWeeklyForecastList(body: any) {
    const query = Object.keys(body).map(key=> {
      return `${key}=${body[key]}`;
    }).join('&');
    return this.http.get(`${this.environment.AppItemPromotionPlanner}/GetPromotionItemPlannerDetailWeeklyForecastList?${query}`)
      .pipe(map(data => {
        return data;
      }));
  }

  ExportPromotionPlannerDetailDataTemplate() {
    return this.http.get(`${this.environment.AppItemPromotionPlanner}/exportpromotiondetail`)
      .pipe(map(data => {
        return data;
      }));
  }

  ImportPromotionPlannerDetailTemplate(body: any) {
    return this.http.post(`${this.environment.AppItemPromotionPlanner}/importpromotiondetail`, body)
      .pipe(map(data => {
        return data;
      }));
  }

  ImportPromotionPlannerTemplate(body: any) {
    return this.http.post(`${this.environment.AppItemPromotionPlanner}/import`, body)
      .pipe(map(data => {
        return data;
      }));
  }

  GetActivePromotionByFixtureAndDateRange(body: any) {
    const query = Object.keys(body).map(key=> {
      return `${key}=${body[key]}`;
    }).join('&');
    return this.http.get(`${this.environment.AppItemPromotionPlanner}/getpromotionitemplanneractivecountondaterangefixture?${query}`)
      .pipe(map(data => {
        return data;
      }));
  }

  GetPromotionPlannerDisabledPositionList(body: any) {
    const query = Object.keys(body).map(key=> {
      return `${key}=${body[key]}`;
    }).join('&');
    return this.http.get(`${this.environment.AppItemPromotionPlanner}/getpromotiondetaildisabledpositionlist?${query}`)
      .pipe(map(data => {
        return data;
      }));
  }

}
